export const formValidation = {
  minLength: 9,
};
